(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-pricing-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const getModal = () => document.getElementById('B2BPricingModal');

    const openModal = (modal) => {
      if (modal.open) return;
      modal.show();
      document.body.classList.add('overflow-hidden');
    };

    document.addEventListener('keydown', function (event) {
      const modal = getModal();
      if (event.key === 'Escape' && modal?.open) modal.close();
    });

    document.addEventListener('click', function (event) {
      const modal = getModal();
      if (!modal) return;

      if (event.target.closest('[data-b2b-pricing-open]')) {
        event.preventDefault();
        openModal(modal);
        return;
      }

      if (event.target.closest('[data-b2b-sign-in]')) {
        modal.close();
        const trigger = document.querySelector('#B2BPricingAccount [data-b2b-sign-in-trigger]');
        // Deferred so this click finishes first and can't count as an outside click that closes the sheet
        if (trigger) setTimeout(() => trigger.click(), 0);
        return;
      }

      if (event.target === modal || event.target.closest('[data-b2b-pricing-close]')) {
        modal.close();
      }
    });

    document.addEventListener(
      'close',
      function (event) {
        if (event.target.id === 'B2BPricingModal') document.body.classList.remove('overflow-hidden');
      },
      true
    );

    if (window.Shopify && Shopify.designMode) {
      const belongsToModal = (event, modal) => event.target.contains(modal) || modal.contains(event.target);

      ['shopify:section:select', 'shopify:block:select'].forEach((name) => {
        document.addEventListener(name, function (event) {
          const modal = getModal();
          if (modal && belongsToModal(event, modal)) openModal(modal);
        });
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        const modal = getModal();
        if (modal && belongsToModal(event, modal)) modal.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerElement = document.querySelector('.header');
      this.aaPanelElement = document.querySelector('.header-panel-container');
      this.stickyAnnouncementBar = document.querySelector('[data-enable-sticky-announcement-bar="true"]');
      this.stickyAnnouncementSection = this.stickyAnnouncementBar ? this.stickyAnnouncementBar.closest('.announcement-bar-section, .shopify-section') : null;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.scrollThreshold = 100;
      
      // Store original header height - critical for preventing layout shifts
      this.originalHeaderHeight = this.headerElement ? this.headerElement.offsetHeight : 0;
      
      // Apply initial styles to prevent layout shifts
      if (this.headerElement) {
        // Add a CSS variable that can be used in your stylesheet
        document.documentElement.style.setProperty('--original-header-height', `${this.originalHeaderHeight}px`);
        
        // Add a specific class to indicate the header has been initialized
        this.headerElement.classList.add('header-measurement-complete');
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Use passive scrolling for better performance
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      
      // Apply initial scroll state
      this.applyScrollState(window.pageYOffset || document.documentElement.scrollTop);
      this.updateAnnouncementStickyState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    
    // Apply classes based on scroll position, but never remove them during scrolling
    applyScrollState(scrollTop) {
      if (this.headerElement) {
        // Use a data attribute instead of a class to avoid layout shifts
        this.headerElement.setAttribute('data-scroll-position', scrollTop);
        
        if (scrollTop >= this.scrollThreshold) {
          // Only add the class, never remove it during scroll
          if (!this.headerElement.classList.contains('scrolled-threshold')) {
            this.headerElement.classList.add('scrolled-threshold');
            this.aaPanelElement.classList.add('scrolled');
          }
        }
      }
    }

    updateAnnouncementStickyState() {
      if (!this.stickyAnnouncementSection || !this.header) return;
      // Floored fractional height, not offsetHeight — rounding up leaves a hairline gap
      // between the bar and the header on high-density screens.
      const announcementHeight = Math.floor(this.stickyAnnouncementSection.getBoundingClientRect().height);
      document.documentElement.style.setProperty(
        '--sticky-announcement-bar-height',
        `${announcementHeight}px`
      );
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Simply update the data attribute without removing classes
      this.applyScrollState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.updateAnnouncementStickyState();
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        
        // Only remove the scrolled-threshold class when completely at the top
        if (scrollTop === 0 && this.headerElement) {
          this.headerElement.classList.remove('scrolled-threshold');
          this.aaPanelElement.classList.remove('scrolled');
        }
        
        requestAnimationFrame(this.reset.bind(this));
      }

      this.updateAnnouncementStickyState();
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-contact"] && !Shopify.designMode) return;
  try {
    
  $('body').on('click', '.zendesk__trigger-open', function(e) {
    e.preventDefault();

    // Assuming `zE` is globally available after including Zendesk's script
    if (typeof zE !== 'undefined') {
        if (zE.widget === 'messenger') {
          zE('messenger', 'open');
        } else {
          zE.activate();
        }
    }
  })

  } catch(e) { console.error(e); }
})();
})();
